const collectionsLightboxState = {
  active: null,
  keydownBound: false
};

function initFeaturedProductsSwiper(container) {
  if (!container || container.dataset.swiperReady === 'true') return;
  if (typeof Swiper === 'undefined') return;
  if (container.querySelectorAll('.swiper-slide').length <= 1) return;

  const swiperInstance = new Swiper(container, {
    slidesPerView: 2.5,
    spaceBetween: 2,
    speed: 400,
    grabCursor: true,
    watchOverflow: true,
    breakpoints: {
      820: {
        spaceBetween: 16,
        slidesPerView: 3.5
      },
      1200: {
        slidesPerView: 4.5
      }
    }
  });

  container.swiperInstance = swiperInstance;
  container.dataset.swiperReady = 'true';
}

function initAllFeaturedProductsSwipers() {
  if (typeof Swiper === 'undefined') return;
  const swipers = document.querySelectorAll('[data-featured-products-swiper]');
  swipers.forEach(initFeaturedProductsSwiper);
}

window.initAllFeaturedProductsSwipers = initAllFeaturedProductsSwipers;

function closeOtherCollectionLightboxes(exceptLightbox) {
  document.querySelectorAll('[data-collection-lightbox]').forEach(function (other) {
    if (other === exceptLightbox) return;
    other.hidden = true;
    const otherStage = other.querySelector('[data-collection-lightbox-stage]');
    if (otherStage) otherStage.innerHTML = '';
  });
  if (collectionsLightboxState.active && collectionsLightboxState.active.lightbox !== exceptLightbox) {
    collectionsLightboxState.active = null;
  }
}

function initCollectionsLightbox(sectionRoot) {
  if (!sectionRoot || sectionRoot.dataset.lightboxReady === 'true') return;

  const lightbox = sectionRoot.querySelector('[data-collection-lightbox]');
  const dialog = sectionRoot.querySelector('.page-collections-lightbox-dialog');
  const stage = sectionRoot.querySelector('[data-collection-lightbox-stage]');
  const triggers = Array.from(sectionRoot.querySelectorAll('[data-collection-lightbox-trigger]'));
  const prevButton = sectionRoot.querySelector('[data-collection-lightbox-prev]');
  const nextButton = sectionRoot.querySelector('[data-collection-lightbox-next]');
  const closeButtons = Array.from(sectionRoot.querySelectorAll('[data-collection-lightbox-close]'));
  if (!lightbox || !dialog || !stage || !triggers.length) return;

  let currentIndex = 0;
  let activeTrigger = null;
  const warmedImageUrls = new Set();

  const normalizedIndex = function (index) {
    const total = triggers.length;
    if (!total) return 0;
    return (index + total) % total;
  };

  const setMediaIndexState = function () {
    if (prevButton) prevButton.disabled = triggers.length <= 1;
    if (nextButton) nextButton.disabled = triggers.length <= 1;
    if (prevButton) prevButton.hidden = triggers.length <= 1;
    if (nextButton) nextButton.hidden = triggers.length <= 1;
  };

  const wrapLightboxFigure = function (mediaElement) {
    const figure = document.createElement('figure');
    figure.className = 'figure-media page-collections-lightbox-figure';
    const container = document.createElement('div');
    container.className = 'media-container';
    figure.appendChild(container);
    container.appendChild(mediaElement);
    return figure;
  };

  const cloneMediaForStage = function (trigger) {
    const imageUrl = trigger.getAttribute('data-lightbox-image-url');
    const imageSrcset = trigger.getAttribute('data-lightbox-image-srcset');

    if (imageUrl) {
      const image = document.createElement('img');
      image.className = 'media page-collections-lightbox-media';
      const thumbImg = trigger.querySelector('img');
      image.alt = thumbImg && thumbImg.getAttribute('alt') ? thumbImg.getAttribute('alt') : '';
      image.src = imageUrl;
      image.loading = 'eager';
      image.decoding = 'async';
      if (imageSrcset) {
        image.srcset = imageSrcset;
        image.sizes = '92vw';
      }
      return wrapLightboxFigure(image);
    }

    const sourceVideo = trigger.querySelector('video');
    if (!sourceVideo) return null;

    const video = sourceVideo.cloneNode(true);
    video.className = 'media page-collections-lightbox-media';
    video.removeAttribute('controls');
    video.controls = false;
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.setAttribute('playsinline', '');
    video.playsInline = true;
    if (!video.hasAttribute('loop')) {
      video.loop = true;
    }
    video.removeAttribute('data-autoplay-managed');
    return wrapLightboxFigure(video);
  };

  const tryPlayLightboxVideo = function (figureRoot) {
    const video = figureRoot && figureRoot.querySelector('video');
    if (!video) return;
    const result = video.play();
    if (result && typeof result.catch === 'function') {
      result.catch(function () {});
    }
  };

  const renderMedia = function (index) {
    currentIndex = normalizedIndex(index);
    const mediaClone = cloneMediaForStage(triggers[currentIndex]);
    if (!mediaClone) return;
    stage.innerHTML = '';
    stage.appendChild(mediaClone);
    tryPlayLightboxVideo(mediaClone);
    setMediaIndexState();
  };

  const openLightbox = function (index, trigger) {
    closeOtherCollectionLightboxes(lightbox);
    activeTrigger = trigger || null;
    renderMedia(index);
    lightbox.hidden = false;
    document.documentElement.classList.add('collections-lightbox-open');
    collectionsLightboxState.active = {
      lightbox: lightbox,
      close: closeLightbox,
      showNext: showNext,
      showPrevious: showPrevious,
      getFocusableElements: getFocusableElements
    };
    warmAdjacentImages(currentIndex);
    const focusableElements = getFocusableElements();
    if (focusableElements.length) {
      focusableElements[0].focus();
    }
  };

  const closeLightbox = function () {
    lightbox.hidden = true;
    stage.innerHTML = '';
    document.documentElement.classList.remove('collections-lightbox-open');
    if (collectionsLightboxState.active && collectionsLightboxState.active.lightbox === lightbox) {
      collectionsLightboxState.active = null;
    }
    if (activeTrigger && typeof activeTrigger.focus === 'function') {
      activeTrigger.focus();
    }
    activeTrigger = null;
  };

  const showNext = function () {
    renderMedia(currentIndex + 1);
  };

  const showPrevious = function () {
    renderMedia(currentIndex - 1);
  };

  const warmImageCache = function (trigger) {
    const imageUrl = trigger.getAttribute('data-lightbox-image-url');
    if (!imageUrl || warmedImageUrls.has(imageUrl)) return;
    const preloadImage = new Image();
    preloadImage.src = imageUrl;
    warmedImageUrls.add(imageUrl);
  };

  const warmAdjacentImages = function (index) {
    if (triggers.length <= 1) return;
    const nextIndex = normalizedIndex(index + 1);
    const previousIndex = normalizedIndex(index - 1);
    warmImageCache(triggers[nextIndex]);
    warmImageCache(triggers[previousIndex]);
  };

  const getFocusableElements = function () {
    const selector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    return Array.from(dialog.querySelectorAll(selector)).filter(function (element) {
      return !element.disabled && element.offsetParent !== null;
    });
  };

  triggers.forEach(function (trigger, index) {
    trigger.addEventListener('mouseenter', function () {
      warmImageCache(trigger);
    }, { passive: true });
    trigger.addEventListener('focus', function () {
      warmImageCache(trigger);
    });
    trigger.addEventListener('touchstart', function () {
      warmImageCache(trigger);
    }, { passive: true });

    trigger.addEventListener('click', function () {
      openLightbox(index, trigger);
    });
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeLightbox);
  });

  if (prevButton) prevButton.addEventListener('click', showPrevious);
  if (nextButton) nextButton.addEventListener('click', showNext);

  sectionRoot.dataset.lightboxReady = 'true';
}

function initAllCollectionsLightboxes() {
  const sections = document.querySelectorAll('[data-page-collections-group]');
  sections.forEach(initCollectionsLightbox);
}

function bindCollectionsLightboxGlobalKeydown() {
  if (collectionsLightboxState.keydownBound) return;

  document.addEventListener('keydown', function (event) {
    const active = collectionsLightboxState.active;
    if (!active || active.lightbox.hidden) return;

    if (event.code === 'Escape') {
      active.close();
      return;
    }
    if (event.code === 'ArrowRight') {
      active.showNext();
      return;
    }
    if (event.code === 'ArrowLeft') {
      active.showPrevious();
      return;
    }
    if (event.code !== 'Tab') return;

    const focusableElements = active.getFocusableElements();
    if (focusableElements.length < 2) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
      return;
    }
    if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  });

  collectionsLightboxState.keydownBound = true;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initAllFeaturedProductsSwipers();
    initAllCollectionsLightboxes();
    bindCollectionsLightboxGlobalKeydown();
  }, { once: true });
} else {
  initAllFeaturedProductsSwipers();
  initAllCollectionsLightboxes();
  bindCollectionsLightboxGlobalKeydown();
}
document.addEventListener('shopify:section:load', initAllFeaturedProductsSwipers);
document.addEventListener('shopify:section:load', initAllCollectionsLightboxes);
window.addEventListener('load', initAllFeaturedProductsSwipers);
